export type Enum<K extends string> = { [P in K]: P }

// ts-pattern https://github.com/gvergnaud/ts-pattern/issues/183#issuecomment-2817090910
export function enumValue<const T>(
  value: T
): `${Extract<T, number>}` extends `${infer N extends number}` ? N : T {
  return value as `${Extract<T, number>}` extends `${infer N extends number}`
    ? N
    : T
}
